import { loadView } from '@/router'

export default [

  {
    path: 'locations',
    name: 'configuration-locations',
    component: loadView('Application/Configuration/Locations'),
    props: true,
    redirect: {
      name: 'configuration-locations-list'
    },
    children: [
      {
        path: 'list',
        name: 'configuration-locations-list',
        component: loadView('Application/Configuration/Locations/List'),
        props: true
      },
      {
        path: ':locationId',
        name: 'configuration-locations-location',
        component: loadView('Application/Configuration/Locations/Location'),
        props: true,
        redirect: {
          name: 'configuration-locations-location-detail'
        },
        children: [
          {
            path: 'detail',
            name: 'configuration-locations-location-detail',
            component: loadView('Application/Configuration/Locations/Location/Detail'),
            props: true
          }
        ]
      }
    ]
  }
]
